export * as generalOperations from "./operations";